import { createSelector } from 'reselect';
import { LOADING_STATUSES } from 'constants/loadingStatuses';

const selectDictionariesState = (state) => state.dictionaries.list;

export const selectDictionariesListCache = createSelector(selectDictionariesState, (state) => state.cache);
export const selectDictionariesListData = createSelector(selectDictionariesState, (state) => state.data);
export const selectDictionariesListLoading = createSelector(selectDictionariesState, (state) => state.status === LOADING_STATUSES.LOADING);
